import { TreeNode } from '../route-builder';

export const HeadcountOverviewModule = {
  segment: 'headcount-overview',
  children: {
    HeadcountOverviewComponent: { segment: '' },
    HeadcountOverviewIntroductionComponent: { segment: 'introduction' }
  }
} as const satisfies TreeNode;
